export function withErrorHandling<T extends unknown[], K>(
  fn: (...args: T) => K,
): (...args: T) => K | undefined {
  return (...args: T) => {
    try {
      return fn(...args);
    } catch (error) {
      console.error(error);
    }
  };
}
